import { render, staticRenderFns } from "./GenericCheck.vue?vue&type=template&id=5b27cb1e"
import script from "./GenericCheck.vue?vue&type=script&lang=js"
export * from "./GenericCheck.vue?vue&type=script&lang=js"
import style0 from "./GenericCheck.vue?vue&type=style&index=0&id=5b27cb1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports